import React from "react";

import "./RunningHealth.css";

import Banner from "../../../sections/Banner/Banner";
import VideoCard from "../../../components/VideoCard/VideoCard";
import LoginOnly from "../../../sections/LoginOnly/LoginOnly";
import Button from "../../../components/Button/Button";
import Accordion from "../../../sections/Accordion/Accordion";

const runningHealth = () => {
  return (
    <div className="RunningHealth">
      <Banner
        img_src="https://districttrack.s3.us-east-2.amazonaws.com/v2/photos/running/men-birddog.jpg"
        img_alt="Men's Team working out near the Washington Monument."
      >
        <h1>Running Health</h1>
      </Banner>

      {/* <section>
        <h5>Sponsored by</h5>
        <img
          alt="Resurgent Logo"
          className="Logo"
          src="https://districttrack.s3.us-east-2.amazonaws.com/assets/media/partners/Resurgent.png"
        />
      </section> */}

      <LoginOnly>
        <section>
          <div>
            <VideoCard full videoId="rq932RODZZQ">
              <h3>MEET RESURGENT SPORTS REHAB</h3>
              <p>
                Resurgent Sports Rehab is a modern rehabilitation and wellness
                clinic specializing in chiropractic care, physical therapy,
                massage therapy, nutrition, student athletics, and sports
                performance training.
              </p>
              <p>
                In collaboration with Resurgent Sports Rehab, District Track
                Club is proud to present the Running Health Series. The videos
                below have been created to offer specific and strategic advice
                on how to understand injuries and learn more about why they
                happen, how to test for them, and most importantly how to fix
                them.
              </p>
              <h5>STILL HAVE QUESTIONS FOR THE DOCTOR?</h5>
              <br></br>
              <Button
                to="mailto:Kerri@resurgentsports.com"
                buttonType="Primary"
                size="sm"
              >
                Submit A Question
              </Button>
            </VideoCard>
          </div>
        </section>
        <section>
          {/* <h2>Running Health Videos</h2> */}
          <Accordion>
            <div title="Test Your Running Health">
              <VideoCard videoId="jB9h3PvHnIo">
                <h5>Healthy Running Screen with Resurgent Sports Rehab</h5>
              </VideoCard>
            </div>
            <div title="Hips, Glutes, & Hamstrings">
              <VideoCard videoId="EYriQqQ7Twc">
                <h5>Understanding Sacroiliac Joint Dysfunction</h5>
              </VideoCard>
              <VideoCard videoId="6j8jE_izRL8">
                <h5>Understanding Lateral Hip Pain</h5>
              </VideoCard>
              <VideoCard videoId="V0tInqiM-_I">
                <h5>Understanding Hip Labral Tears</h5>
              </VideoCard>
              <VideoCard videoId="KspkH9gRvT0">
                <h5>Understanding High Hamstring Tendinopathy</h5>
              </VideoCard>
            </div>
            <div title="Back & Trunk">
              <VideoCard videoId="gLUuRNDMCfw">
                <h5>Understanding Lumbar Disc Issues</h5>
              </VideoCard>
              <VideoCard videoId="fdZZjSESpys">
                <h5>Understanding Low Back Instability</h5>
              </VideoCard>
            </div>
            <div title="Quad & Knee">
              <VideoCard videoId="Pc-B773YHkQ">
                <h5>Understanding Patellar Tendinopathy</h5>
              </VideoCard>
              <VideoCard videoId="wR7ByCf_I6I">
                <h5>Understanding Runner's Knee</h5>
              </VideoCard>
              <VideoCard videoId="YC07wVn296c">
                <h5>Understanding IT Band Syndrome</h5>
              </VideoCard>
            </div>
            <div title="Lower Leg & Foot">
              <VideoCard videoId="MsloskToIvw">
                <h5>Understanding Shin Splints</h5>
              </VideoCard>
              <VideoCard videoId="xJjQS7XuTpY">
                <h5>Understanding Achilles Tendinopathy</h5>
              </VideoCard>
              <VideoCard videoId="rC27dHkMDYM">
                <h5>Understanding Posterior Tibialis Tendinosis</h5>
              </VideoCard>
              <VideoCard videoId="QHDNaDg0uMM">
                <h5>Understanding Bunions</h5>
              </VideoCard>
              <VideoCard videoId="AtBLHHiG7_k">
                <h5>Understanding Plantar Fasciitis</h5>
              </VideoCard>
            </div>
          </Accordion>
        </section>
      </LoginOnly>
    </div>
  );
};

export default runningHealth;
